<template>
  <section class="grid grid-cols-2 lg:grid-cols-4 gap-4 pb-40 h-fit">
    <PageHeader
      class="col-span-1 lg:col-span-2"
      title="User Activities"
      subtitle="All Activities"
    />

    <Card card_class="col-span-2 lg:col-span-4">
      <AlertConfirmation
        v-if="alert_confirmation"
        @confirmNo="cancelDelete"
        @confirmYes="confirmDelete"
        text="Are you sure you want to delete this activity?"
      />

      <DinamicTable :header_columns="table_header" th_class="text-left">
        <TableRow v-if="!allUserActivities || allUserActivities.length === 0">
          <td colspan="7" class="p-3 text-center italic text-white tracking-widest">
            ~ Belum ada data ~
          </td>
        </TableRow>

        <TableRow v-else v-for="(activity, index) in allUserActivities" :key="index">
          <!-- <TableCell>{{ index + 1 + (pagination.page - 1) * pagination.perPage }}</TableCell> -->
          <TableCell>{{ activity.activity_type }}</TableCell>
          <!-- <TableCell>{{ activity.description }}</TableCell> -->
          <TableCell>{{ activity.user_id }}</TableCell>
          <TableCell>{{ formatDate(activity.createdAt) }}</TableCell>
        </TableRow>
      </DinamicTable>

      <Pagination
        :totalItems="pagination.totalItems"
        :perPage="parseInt(pagination.perPage)"
        :currentPage="parseInt(pagination.page)"
        :previousPageLink="pagination?.previousPageLink"
        :nextPageLink="pagination?.nextPageLink"
        @page-changed="fetchUserActivities"
      />
    </Card>
  </section>
</template>

<script>
import Card from "@/components/organisms/Card.vue";
import PageHeader from "@/components/molecules/PageHeader.vue";
import DinamicTable from "@/components/organisms/DinamicTable.vue";
import TableRow from "@/components/atoms/table/TableRow.vue";
import TableCell from "@/components/atoms/table/TableCell.vue";
import TableButtonView from "@/components/atoms/table/TableButtonView.vue";
import TableButtonDelete from "@/components/atoms/table/TableButtonDelete.vue";
import AlertConfirmation from "@/components/alerts/AlertConfirmation.vue";
import Pagination from "@/components/organisms/Pagination.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'UserActivities',
  components: {
    PageHeader,
    DinamicTable,
    Card,
    TableRow,
    TableCell,
    TableButtonView,
    TableButtonDelete,
    AlertConfirmation,
    Pagination,
  },
  data() {
    return {
      table_header: ['Activity Type', 'Username', 'Created At'],
      alert_confirmation: false,
      activityIdToDelete: null,
    };
  },
  computed: {
    ...mapGetters('userActivities', ['allUserActivities', 'pagination']),
  },
  methods: {
    ...mapActions('userActivities', ['fetchUserActivities']),
    
    fetchUserActivities(page = 1, limit = 10) {
      const params = {
        page: page,
        limit: limit
      };
      this.$store.dispatch('userActivities/fetchUserActivities', params);
    },

    formatDate(dateString) {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      return new Date(dateString).toLocaleString(undefined, options);
    },
  },
  created() {
    this.fetchUserActivities(1);
  }
};
</script>

<style scoped>
/* Additional styling if necessary */
</style>
